import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './i18n'

import GraphqlApi from './graphql-api'
import formSubmissionQuery from './qql/formSubmission.graphql'
import createFormSubmissionQuery from './qql/createFormSubmission.graphql'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    customer_name: '',
    form_submission_id: null,
    submission_state: '',
    form_template: {}
  },
  getters: {
    customerName: state => state.customer_name,
    formSubmissionId: state => state.form_submission_id,
    submissionState: state => state.submission_state,
    formTemplate: state => state.form_template,
    formSubmission: state => () => {
      const answers = []
      state.form_template.questions.map(question => {
        if (question.answer) {
          let questionAnswer;
          if (question.questionType === 'checkbox') {
            questionAnswer = { multipleAnswers: question.answer, answer: null, questionId: question.id }
          } else {
            let answer = ''
            if (question.questionType === 'boolean' && question.answer === 'no') {
              answer = 'false'
            } else {
              answer = question.answer
            }
            questionAnswer = { answer, multipleAnswers: null, questionId: question.id }
          }
          answers.push(questionAnswer)
        }
      });
      return { id: state.form_submission_id, answers }
    }
  },
  mutations: {
    SET_INITIAL_DATA(state, payload) {
      state.customer_name = payload.customer_name;
      state.form_submission_id = payload.form_submission_id;
      state.submission_state = payload.submission_state;

      payload.form_template.questions.forEach(question => {
        if (question.questionType === 'checkbox') {
          question.answer = []
        } else {
          question.answer = '';
        }
        
        if (question.options && typeof question.options === 'string') {
          question.options = question.options.split('\n');
        }
      });
      state.form_template = payload.form_template;
    },
    SET_SUBMISSION_STATE(state, payload) {
      state.submission_state = payload;
    }
  },
  actions: {
    getFormSubmission(context, payload) {
      const GraphqlApiService = new GraphqlApi();
      GraphqlApiService.post(formSubmissionQuery.loc.source.body, { id: payload.id }, 'getFormSubmission').then(response => {
        const formSubmission = response.data.formSubmission;
        i18n.locale = formSubmission.template.company.language;
        context.commit('SET_INITIAL_DATA', {
          customer_name: formSubmission.customer.fullName,
          form_template: formSubmission.template,
          form_submission_id: formSubmission.id,
          submission_state: formSubmission.state
        });
      })
    },
    saveFormSubmission(context) {
      const GraphqlApiService = new GraphqlApi();
      GraphqlApiService.post(createFormSubmissionQuery.loc.source.body, { input: context.getters.formSubmission() }, 'createFormSubmission').then(response => {
        const formSubmission = response.data.createFormSubmission;
        if (formSubmission) {
          context.commit('SET_SUBMISSION_STATE', formSubmission.submission.state);
        } else {
          context.commit('SET_SUBMISSION_STATE', 'not_found');
        }
      })
    },
  }
})
export default store;
